import {useFetchHousing, useFetchHousingLocation} from '../../hooks';
import {useChekinSDK} from '../../context/ChekinSDK';

function useHousing() {
  const {objectId: housingId} = useChekinSDK();
  const {data: housing, isSuccess: isSuccessLoadedHousing} = useFetchHousing(housingId, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const {data: locationCountry, isSuccess: isSuccessLoadedHousingLocation} =
    useFetchHousingLocation({
      housingLocation: housing?.location,
    });

  return {
    housing,
    housingLocation: locationCountry,
    housingCountry: locationCountry?.country?.code,
    isLoaded: isSuccessLoadedHousing && isSuccessLoadedHousingLocation,
  };
}

export {useHousing};
